/**
Copyright (C) 2018 Andras Sarvari <andras.sarvari@sarvaria.net>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/

/* jshint browser: true, esversion: 6, node:true */
/* globals console */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CloseIcon from './baseline_close_black_24dp.png';
import './Dialog.css';

/**
 * Represents the dialog component.
 */

export default class Dialog extends Component {

    /**
     * Properties.
     */

    static propTypes = {
        width:              PropTypes.number,
        height:             PropTypes.number,
        closetooltip:       PropTypes.string,
        hideclosebutton:    PropTypes.bool,
        onOpen:             PropTypes.func,
        onClose:            PropTypes.func
    }

    /**
     * Default property values.
     */

    static defaultProps = {
        width:              400,
        height:             200
    }

    /**
     * Default state.
     */

    state = { 
        show:               false,
        visible:            false
    }

    /**
     * Closes the dialog when the dialog is not modal.
     */

    _closeOnModal = () => {
        if (!this.props.modal) {
            this.close();
        }
    }

    /**
     * Opens the dialog and callback the "onClose" event.
     */

    open = () => {

        // Creating and returning the promise object

        return new Promise((resolve, reject) => {        
            this.setState({ visible: true }, () => {
                setTimeout(() => {
                    this.setState({ show: true });

                    // Firing the "onOpen" event if it is defined

                    if (this.props.onOpen) {
                        this.props.onOpen();
                    }
                    
                    // Resolving

                    resolve();                    
                }, 20);
            });
        });
    }

    /**
     * Closes the dialog and callback the "onClose" event.
     * 
     * @return  {Promise}   promise         promise object
     */

    close = () => {

        // Creating and returning the promise object

        return new Promise((resolve, reject) => {
            this.setState({ show: false }, () => {
                setTimeout(() => {
                    this.setState({ visible: false });

                    // Firing the "onClose" event if it is defined

                    if (this.props.onClose) {
                        this.props.onClose();
                    }

                    // Resolving

                    resolve();
                }, 250);
            });
        });
    }

    /** 
     * Dialog renderer.
     */

    render() {
        return (
            this.state.visible && <div className="dialog vertical" style={{ opacity: this.state.show ? 1 : 0 }}>
                    
                {/* Backdrop */}

                <div className="dialog-background fit horizontal vertical center-justified center"></div>
                
                {/* Dialog frame */}                    
                
                <div className="dialog-container fit horizontal vertical center-justified center" onClick={this._closeOnModal}>
                    <div className="dialog-container-content" style={{ width: this.props.width + 'px', height: this.props.height + 'px' }} onClick={(event) => {event.stopPropagation();}}>

                        {/* Close button */}

                        { !this.props.hideclosebutton &&
                            <img alt="Close" src={CloseIcon} className="dialog-container-content-close" title={this.props.closetooltip} onClick={this.close}></img>
                        }

                        {/* Content of the dialog */}

                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Dialog/Dialog.js